import { maintenanceTemplateDeleteBlock, type MaintenanceTemplate } from '@gb-ticket/shared-types';

export type TemplateBatchRow = Pick<MaintenanceTemplate, 'id' | 'name' | 'usageCount' | 'isActive'>;

export type TemplateBatchSplit = {
  allowed: TemplateBatchRow[];
  rejected: { row: TemplateBatchRow; reason: string }[];
};

/** Same rule as a single delete: a template with orders or protocols stays. */
export function partitionTemplateDelete(rows: readonly TemplateBatchRow[]): TemplateBatchSplit {
  const allowed: TemplateBatchRow[] = [];
  const rejected: TemplateBatchSplit['rejected'] = [];
  for (const row of rows) {
    const reason = maintenanceTemplateDeleteBlock(row.usageCount);
    if (reason) {
      rejected.push({ row, reason });
    } else {
      allowed.push(row);
    }
  }
  return { allowed, rejected };
}

/** Archiving only turns the template off. Use does not block it. */
export function partitionTemplateArchive(rows: readonly TemplateBatchRow[]): TemplateBatchSplit {
  const allowed: TemplateBatchRow[] = [];
  const rejected: TemplateBatchSplit['rejected'] = [];
  for (const row of rows) {
    if (row.isActive) {
      allowed.push(row);
    } else {
      rejected.push({ row, reason: 'Die Vorlage ist bereits deaktiviert.' });
    }
  }
  return { allowed, rejected };
}
